import { Button, FixedInfoBanner } from '@kanda-libs/ks-design-library';
import { URLS } from 'config';
import { Link } from 'react-router-dom';
import useExampleBanner from './useExampleBanner';

const ExampleBanner: React.FunctionComponent = function () {
  const { visible } = useExampleBanner();
  return (
    <FixedInfoBanner visible={visible} variant="violet">
      <div className="flex flex-row flex-1 justify-between items-center gap-x-4">
        <p className="text-16-20 text-neutral-000">
          This application is an example application
        </p>
        <Link to={URLS.home}>
          <Button.Text
            id="howdens-example-banner-home"
            label="Return to home"
            variant="gradient"
            size={40}
          />
        </Link>
      </div>
    </FixedInfoBanner>
  );
};

export default ExampleBanner;
